export const testId = {
    addAgent: "add-agent",
    deleteAgent: "delete-agent",
    saveAgent: "save-agent",
    extractParametersSelect: "extract-parameters-select"
} as const
